import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CalendarHeart, CalendarRange, CalendarOff } from "lucide-react";
import {
  getAppointment,
  getAppointmentCounter,
} from "../../redux/action/Appointment";
import dayjs from "dayjs";

const TONES = {
  purple: { tile: "bg-[#F5F3FF] text-[#7C3AED]", badge: "bg-[#F5F3FF] text-[#7C3AED]" },
  teal: { tile: "bg-[#F0FDFA] text-[#0D9488]", badge: "bg-[#ECFDF5] text-[#059669]" },
  rose: { tile: "bg-[#FFF1F2] text-[#E11D48]", badge: "bg-[#FFF1F2] text-[#E11D48]" },
};

const StatCard = ({ icon: Icon, tone, badge, value, title, sub1, sub2 }) => (
  <div className="flex flex-col justify-between h-full bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl p-[14px] w-full shadow-sm hover:shadow-md transition-shadow">
    <div className="flex items-start justify-between mb-2">
      <div
        className={`flex items-center justify-center w-[34px] h-[34px] rounded-lg ${TONES[tone].tile}`}
      >
        <Icon size={17} />
      </div>
      {badge ? (
        <span
          className={`px-2 py-0.5 rounded-full text-[10px] font-semibold font-poppins ${TONES[tone].badge}`}
        >
          {badge}
        </span>
      ) : null}
    </div>
    <div>
      <div className="text-[22px] leading-tight font-bold text-[#171717] font-poppins">
        {value}
      </div>
      <div className="mt-0.5 text-[10px] uppercase tracking-wide font-medium text-[#64748B] font-poppins">
        {title}
      </div>
    </div>
  </div>
);

const Index = () => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.APPOINTMENT_COUNTER);
  const [todayAppointments, setTodayAppointments] = useState([]);
  const [totalAppointments, setTotalAppointments] = useState(0);
  const [missedReports, setMissedReports] = useState([]);

  const getAppointmentData = () => {
    const payload = {};
    dispatch(getAppointmentCounter(payload));
  };

  const processAppointments = () => {
    const todayDate = dayjs().format("YYYY-MM-DD");

    // Flatten and filter out any null/undefined items
    const allAppointments = Object.values(data).flat().filter(Boolean);

    // Today's appointments
    const todays = allAppointments.filter(
      (appt) =>
        appt.date === todayDate &&
        new Date(`${appt.date}T${appt.startTime}`) >= new Date()
    );

    // Missed Reports: completed + no url
    const missed = allAppointments.filter(
      (appt) => appt.status === "COMPLETED" && appt.url === null
    );

    setTodayAppointments(todays);
    setTotalAppointments(allAppointments.length);
    setMissedReports(missed);
  };

  useEffect(() => {
    getAppointmentData();
    // const interval = setInterval(getAppointmentData, 5000);
    // return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    processAppointments();
  }, [data]);
  return (
    <div className="p-0">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-[720px]">
        <StatCard
          icon={CalendarHeart}
          tone="purple"
          badge={dayjs().format("DD MMM")}
          value={todayAppointments.length}
          title="Today's Event"
          sub1={`1`}
          sub2={`2`}
        />
        <StatCard
          icon={CalendarRange}
          tone="teal"
          value={0}
          title="Total Event"
          sub1={`0`}
          sub2={`0`}
        />
        <StatCard
          icon={CalendarOff}
          tone="rose"
          value={0}
          title="Missed Event"
          sub1={`0`}
          sub2={`0`}
        />
      </div>
    </div>
  );
};

export default Index;
